import api from '@pray/shared/utils/api';

export type GetImpressionListParams = {
  artistId: string;
  offset?: number;
  limit?: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
  dateRangeStart?: string | null;
  dateRangeEnd?: string | null;
  placement?: string | null;
  platform?: string | null;
};

export const getImpressionList = async ({
  artistId,
  offset = 0,
  limit = 20,
  sortColumn = '',
  sortDirection = 'desc',
  dateRangeStart = null,
  dateRangeEnd = null,
  placement = null,
  platform = null,
}: GetImpressionListParams) => {
  const params: Record<string, string | number> = {};

  if (offset) params.offset = offset;
  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  if (dateRangeStart) params.date_range_start = dateRangeStart;
  if (dateRangeEnd) params.date_range_end = dateRangeEnd;
  if (placement) params.placement = placement;
  if (platform) params.platform = platform;

  const url = `/web/studio/artists/${artistId}/marketing-impressions`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
};
